import { View } from 'es6/components/view'

/**
 * Вид для телефона, зависящего от города
 */

export class CommonCityPhoneView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.listenTo(this.settlement, 'change', this.renderPhone)
  }

  /**
   * Меняем телефон в зависимости от выбранного города.
   * @param {SettlementForm} settlement
   */
  renderPhone (settlement) {
    this.$el.html(settlement.get('phone'))
  }
}
